"use client";

import { confirmOwnership, runVerification, toggleMonitoring } from "@/app/actions";
import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";
import { useState } from "react";

export function VerifyActions({
  siteId,
  monitoringEnabled,
  verified,
}: {
  siteId: string;
  monitoringEnabled: boolean;
  verified: boolean;
}) {
  const router = useRouter();
  const [message, setMessage] = useState("");
  const [pending, setPending] = useState(false);
  const [owned, setOwned] = useState(false);

  return (
    <div className="space-y-3">
      <label className="flex items-start gap-2 text-sm">
        <input type="checkbox" checked={owned} onChange={(e) => setOwned(e.target.checked)} />
        I own this site, or I am allowed to protect it.
      </label>
      <div className="flex flex-wrap items-center gap-3">
        <Button
          disabled={pending || !owned}
          onClick={async () => {
            setPending(true);
            await confirmOwnership(siteId);
            setMessage("Saved as yours. You can use it now.");
            setPending(false);
            router.refresh();
          }}
        >
          Confirm I own this
        </Button>
        <Button
          variant="secondary"
          disabled={pending}
          onClick={async () => {
            setPending(true);
            const result = await runVerification(siteId);
            setMessage(result.ok ? "We found the code." : "Code not found yet. You can still confirm it yourself.");
            setPending(false);
            router.refresh();
          }}
        >
          Check for the code
        </Button>
        <Button
          variant="secondary"
          disabled={!verified}
          onClick={async () => {
            await toggleMonitoring(siteId, !monitoringEnabled);
            router.refresh();
          }}
        >
          {monitoringEnabled ? "Turn monitoring off" : "Turn monitoring on"}
        </Button>
      </div>
      {!verified ? (
        <p className="text-sm text-[var(--warning)]">
          Check the box, then confirm. After that you can add suspects.
        </p>
      ) : null}
      {message ? <p className="text-sm text-[var(--text-muted)]">{message}</p> : null}
    </div>
  );
}
